<template>
    <div class="app no-header">
        <w-questions @save="submit"
                     :changed.sync="changed"
                     :message-text="message.text"
                     :message-type="message.type"
                     :answers="answers"
                     :sense-only="senseOnly"
                     :message-show="message.show"
                     :sections="section ? [section] : []"
                     :show-dont-know="false"/>
    </div>
</template>

<script>

import { lambda } from '../aws'
import questions from '../assets/json/questions'

export default {
    name: 'PoolSettings',
    props: ['pool_id'],
    data () {
        return {
            changed: false,
            message: {
                type: 'info',
                text: '',
                show: false
            },
            curPool: null,
            answers: {
                label: '',
                waterBodyId: this.$route.params.pool_id,
                addr1: '',
                addr2: '',
                city: '',
                state: '',
                zip: '',
                shape: '',
                sizeGallons: '',
                lengthFeet: '',
                lengthInches: '',
                widthFeet: '',
                widthInches: '',
                deepEndFeet: '',
                deepEndInches: '',
                shallowEndFeet: '',
                shallowEndInches: '',
                freeClTarget: '',
                phTarget: '',
                measDoseHr: '',
                measDoseMin: ''
            }
        }
    },
    methods: {
        filterChanged (data) {
            let payload = {}
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    if (
                        (data[key] !== '' && this.answers[key] === undefined) ||
                        (!['measDoseMin', 'measDoseHr'].includes(key) && data[key] !== '' && data[key] && this.answers[key] && data[key].toString() !== this.answers[key].toString()) ||
                        (['measDoseMin', 'measDoseHr'].includes(key) && data[key] !== '' && parseInt(data[key]) !== parseInt(this.answers[key])) ||
                        key === 'waterBodyId'
                    ) {
                        payload[key] = data[key]
                        if (key === 'measDoseMin') payload.measDoseHr = data.measDoseHr
                        if (key === 'measDoseHr') payload.measDoseMin = data.measDoseMin
                    }
                }
            }
            if (payload.zip) payload.zip = parseInt(payload.zip)

            return Object.keys(payload).every((_key) => {
                const question = questions.find(({ key }) => key === _key)
                return !question || ((!question.input_min || question.input_min <= payload[_key]) && (!question.input_max || question.input_max >= payload[_key]))
            }) ? payload : false
        },
        submit (data) {
            this.message.show = false
            this.message.type = 'info'
            this.message.text = ''
            const waterBody = this.filterChanged(data)
            if (waterBody) {
                lambda('updateWaterBody', { waterBody }).then(data => {
                    if (data.code === 'OK') {
                        this.message.show = true
                        this.message.type = 'info'
                        this.message.text = 'Settings Updated'
                    } else if (data.code === 'WATER_BODY_LABEL_EXISTS') {
                        this.message.show = true
                        this.message.type = 'danger'
                        this.message.text = 'You already have a pool with this name'
                    }
                    this.getAnswers()
                })
            }
        },
        getAnswers () {
            lambda('getWaterBody', {
                waterBodyId: this.$route.params.pool_id
            }).then(data => {
                if (!data) return
                this.curPool = data.waterBody
                if (this.curPool) {
                    for (let key in this.curPool) this.$set(this.answers, key, this.curPool[key])
                }
                this.$stopSpinner()
            })
        }
    },
    watch: {
        $route: {
            deep: true,
            handler () {
                this.getAnswers()
            }
        }
    },
    computed: {
        section () {
            return this.$route.query.section
        },
        senseOnly () {
            return this.curPool && this.curPool.pods && this.curPool.pods ? this.curPool.pods[0].pod.senseOnly : false
        }
    },
    created () {
        this.getAnswers()
    }
}
</script>

<style scoped>
    .app {
        max-width: 530px;
        margin: 0 auto;
        padding-left: 17px;
        padding-right: 17px;
    }
</style>
